// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1g5Qt","footer":"Form_footer__1FKVm"};